/**
 * Document utilities
 * Story 239: Coverage linkages without visible anchors
 *
 * Utilities for document-related operations, including anchor generation.
 */

/**
 * Generate a unique anchor ID from a section title.
 * Anchors are internal identifiers used for coverage linkages - not visible to users.
 *
 * Format: <title.words.joined.by.dots.NNN>
 * Example: "Authentication Flow" with seq=5 -> "authentication.flow.005"
 *
 * @param title - The section title to convert
 * @param seq - The section sequence number (used for uniqueness)
 * @returns A unique anchor ID
 */
export function generateAnchorFromTitle(title: string, seq: number): string {
  // Normalize: lowercase, replace non-alphanumeric with dots, collapse multiple dots
  const normalized = title
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '.')
    .replace(/^\.+|\.+$/g, '') // Trim leading/trailing dots
    .replace(/\.{2,}/g, '.'); // Collapse multiple dots

  // Pad sequence to 3 digits for consistent sorting
  const paddedSeq = String(seq).padStart(3, '0');

  // Combine with sequence for uniqueness
  return `${normalized}.${paddedSeq}`;
}
